var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waiting-approval"},[_c('x-svg-icon',{staticClass:"join-tenant-icon",attrs:{"name":"join-org"}}),_c('span',{staticClass:"join-tenant-text"},[_vm._v(" 已成功申请加入「"+_vm._s(_vm.tenantInfo.name)+"」，请耐心等待管理员审核。 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }